import React, {useContext} from 'react'
import {observer} from 'mobx-react'
import PatientPageStore from '../Store/PatientPageStore'
import CellResult from './CellResult'
import moment from 'moment'
import styled from "styled-components";
import {AuthContext} from "../../../../context/AuthContext";
import LinkCell3 from "../../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3";
import Button from '../../../../components/Button'
import {Link} from "react-router-dom";


const Cell = props => {
    return (
        <div className='row__cell'>
            {props.content}
        </div>)
}
const StyledDateCell = styled.div`
  white-space: nowrap;
`

const Row = props => {
    const DateCell = <StyledDateCell
        className="row__cell">{moment(props?.rowData?.result_date).format('DD-MM-YYYY')}</StyledDateCell>

    return (
        <div key={props.id} className='table__row'>
            {DateCell}
				{/*
            <Cell content={props?.rowData?.days_left}/>
            <CellResult patientId={props.patientId} resultId={props.id} rowData={props.rowData} id={props.id}/>
            <LinkCell3 linkRoute={'liteviewer/'+props.id} linkTitle={'Смотреть'}/>
				*/}
				<Cell content={props.index==0 ? 
					<Link title="Смотреть все снимки" to={'liteviewer/'+props.id}>
						<Button size={"small"} text="Смотреть все снимки" style={{width: 170}}/> 
					</Link>
					: undefined }/>
        </div>
    )
}

const PatientResult = observer(
    (props) => {
        const {userId} = useContext(AuthContext)

        const createTable = data => {
            const rows = []
            data.forEach((item, index) => {
                rows.push(<Row key={item.id} patientId={userId} id={item.id} index={index} rowData={item}/>)
            })
            return rows
        }



        return (
            <div className='patient-result page__element'>
                <div className="patient-result__title">
                    {props.title}
                </div>
                <div className="patient-result__table">
                    <div className="table__row first-row">
                        <div className="row__cell">Дата процедуры</div>
                        {/*
						<div className="row__cell">Осталось дней</div>
                        <div className="row__cell">Результат</div>
						*/}
                        <div className="row__cell">Снимок</div>
                    </div>
                    {createTable(PatientPageStore.patientResults)}
                </div>
            </div>
        )
    }
)


export default PatientResult
